var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Mastercard-logo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.358,
    height: 20.014,
    viewBox: "0 0 32.358 20.014",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2569",
    "data-name": "Group 2569"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect19",
    width: 8.757,
    height: 15.732,
    transform: "translate(11.788 2.141)",
    fill: "#ff5a00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_330_",
    d: "M12.371,10.007a10.035,10.035,0,0,1,3.808-7.866,10,10,0,1,0-6.172,17.873,9.953,9.953,0,0,0,6.172-2.141A9.987,9.987,0,0,1,12.371,10.007Z",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M515.779,10.007A10,10,0,0,1,499.6,17.873a10.028,10.028,0,0,0,0-15.732,10,10,0,0,1,16.179,7.866Z",
    transform: "translate(-483.421)",
    fill: "#f79e1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.902001354a709333a56f996029e768df.svg";
export { ForwardRef as ReactComponent };